import { z } from 'zod';

import { ContractType, EmployeeStatus, JobHistoryLevel } from '@/common/graphql';

export const EmployeeDirectReportsFilter = z.object({
  keyword: z.string().default(''),
  statuses: z.array(z.nativeEnum(EmployeeStatus)).default([EmployeeStatus.Active, EmployeeStatus.PreOnboarding]),
  contractTypes: z.array(z.nativeEnum(ContractType)).default([]),
  levels: z.array(z.nativeEnum(JobHistoryLevel)).default([]),
  companyIds: z.array(z.string()).default([]),
  locationIds: z.array(z.string()).default([]),
  jobIds: z.array(z.string()).default([]),
  team: z.string().default(''),
});
export type EmployeeDirectReportsFilterType = z.infer<typeof EmployeeDirectReportsFilter>;
